import { errors } from "../messages";

export function getErrorMessage(error) {
  if (typeof error === "string") return error;

  const errorCodeMap = {
    "auth/email-already-in-use": errors.emailAlreadyInUse,
    "auth/user-not-found": errors.wrongUser,
    "auth/wrong-password": errors.wrongUser,
    CAMPAIGN_MAX_QTY_EXCEDED: errors.maxQtyExcedeed,
    DEMO_LIMITS_ERROR: errors.demoLimitReached,
    EXPIRED_PERMISSION: errors.expiredQrCode,
    EXTERNAL_CODES_SOLD_OUT: errors.codesSoldOut,
    MAX_PRODUCTS_PER_USER_REACHED: errors.maxProducts,
    ORDERS_LIMIT_EXCEEDED: errors.ordersLimitExceeded,
    PERMISSION_ERROR: errors.permissionError,
    PRIMARY_PRODUCT_IS_MANDATORY: errors.primaryMandatory,
    TX_LIMIT_PER_MERCHANT_EXCEEDED: errors.txLimitPerMerchantExceeded,
    CARD_NOT_FOUND: errors.cardNotFound,
    EXISTING_OPERATIONID_IN_TX: errors.existingOperationIdInTx,
    STAMP_NOT_FOUND: errors.stampNotFound,
    PERMISSION_ERROR_CAMPAIGN_NOT_JOINED: errors.wrongBusiness,
    PERMISSION_ERROR_WRONG_MERCHANT: errors.wrongBusiness,
    PRODUCT_NOT_FOUND: errors.productNotFound,
  };

  const errorMessageMap = {
    USER_NOT_VERIFIED: errors.userNotVerified,
    VERIFICATION_TIME_EXPIRED: errors.userNotVerified,
    "ExpirationDate not valid: expiration must be at least one day in the future":
      errors.campaignExpirationPast,
    "Token not authorized for the data's tenantID": errors.tokenNotAuthorized,
    "Cannot delete campaign. Campaign has products associated and is not a demo":
      errors.campaignNotDeletable,
    "VALIDATION_ERROR: Product is expired": errors.expiredProduct,
    "VALIDATION_ERROR: Product is not ACTIVE": errors.usedProduct,
    "UseTerms not signed": errors.notSigned,
    "datastore: no such entity": errors.invalidCode,
    TENANT_NOT_AUTHORIZED: errors.notAuthorized,
    PLAN_QUOTA_EXCEEDED_BUSINESS: errors.planQuotaExceededBusiness,
    PLAN_QUOTA_EXCEEDED_BUSINESS_MANAGER:
      errors.planQuotaExceededBusinessManager,
    USER_NOT_FOUND: errors.userNotFound,
    FREQUENCY_CONSTRAINT_ERROR: errors.frequency,
    FRIEND_USER_NOT_FOUND: errors.wrongFriendCode,
    TX_LIMIT_PER_MERCHANT_EXCEEDED: errors.txLimitPerMerchantExceeded,
    CARD_NOT_FOUND: errors.cardNotFound,
    STAMP_NOT_FOUND: errors.stampNotFound,
    PERMISSION_ERROR_CAMPAIGN_NOT_JOINED: errors.wrongBusiness,
    PERMISSION_ERROR_WRONG_MERCHANT: errors.wrongBusiness,
  };

  if (errorCodeMap[error.code]) return errorCodeMap[error.code];
  if (errorMessageMap[error.message]) return errorMessageMap[error.message];
  return error.message;
}

export function getErrorMessageString(error, intl) {
  const errorMessage = getErrorMessage(error);
  return typeof errorMessage === "string"
    ? errorMessage
    : intl.formatMessage(errorMessage);
}

// it produces an error specific for the authentication, when the provider doesn't provide the user email
export function getAuthEmailNotPresentInfo(provider, error, intl) {
  const info = {
    linkURL: null,
    linkLabel: null,
    title: null,
    text: null,
  };
  if (provider === "facebook.com") {
    info.dialog = true;
    info.text = intl.formatMessage(errors.missingFacebookAuthEmailText);
    info.title = intl.formatMessage(errors.authErrorTitle);
    info.linkURL = intl.formatMessage(errors.missingFacebookAuthEmailLinkURL);
    info.linkLabel = intl.formatMessage(errors.moreInfoLabel);
  } else {
    info.text = getErrorMessageString(error, intl);
  }
  return info;
}
